import React, { useEffect, useState } from 'react';
import { Alert, Button, Card, Collapse, Empty, Image, List, Spin, Tag, Typography } from 'antd';
import apiService from '../../../utils/apiInterceptor';

const answerText = (item) => {
  if (item.value !== undefined && item.value !== null) {
    if (typeof item.value === 'boolean') return item.value ? 'Done' : 'Not done';
    return Array.isArray(item.value) ? item.value.join(', ') : String(item.value);
  }
  if (item.is_done !== undefined && item.is_done !== null) return Number(item.is_done) || item.is_done === true ? 'Done' : 'Not done';
  return 'Not submitted';
};

export default function OrderCleaningReport({ orderId }) {
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [retry, setRetry] = useState(0);
  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError(false);
    apiService.get(`/orders/${orderId}/cleaning-report`)
      .then(response => { if (!cancelled) setJobs(response.jobs || []); })
      .catch(() => { if (!cancelled) setError(true); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [orderId, retry]);

  if (loading) return <div className="py-8 text-center"><Spin tip="Loading cleaning report" /></div>;
  if (error) return <Alert type="warning" message="Cleaning report could not be loaded" action={<Button onClick={() => setRetry(value => value + 1)}>Try again</Button>} />;
  if (!jobs.length) return <Empty description="No linked cleaning report is available for this order." />;
  const checklist = (items) => <List size="small" dataSource={items} renderItem={item => <List.Item><span>{item.label}</span><Typography.Text className="ml-4 whitespace-pre-wrap">{answerText(item)}</Typography.Text></List.Item>} />;
  return <div className="space-y-4">{jobs.map(job => <Card key={job.id} title={<span className="whitespace-normal">{job.title || `Cleaning task #${job.id}`}</span>} extra={<Tag>{job.status}</Tag>}>
    <Typography.Text type="secondary">Cleaning task #{job.id}{job.completed_at ? ` · Completed ${job.completed_at}` : ''}</Typography.Text>
    <div className="my-4"><Typography.Title level={5}>Cleaning notes</Typography.Title><p className="whitespace-pre-wrap">{job.notes || 'No cleaning notes have been submitted.'}</p></div>
    <Typography.Title level={5}>Photos</Typography.Title>
    {job.photos?.length ? <Image.PreviewGroup><div className="flex flex-wrap gap-3">{job.photos.map(photo => <div key={photo.id}><Image src={photo.url} alt={`${photo.phase || 'Cleaning'} photo`} width={140} height={110} style={{ objectFit: 'cover' }} loading="lazy" /><div className="text-xs capitalize">{photo.phase}</div></div>)}</div></Image.PreviewGroup> : <p>No cleaning photos have been uploaded.</p>}
    <Typography.Title level={5} className="mt-4">Checklist report</Typography.Title>
    {job.checklist?.length > 0 && (job.templates?.length ? <Collapse className="mb-4"><Collapse.Panel header="Task checklist" key="task-checklist">{checklist(job.checklist)}</Collapse.Panel></Collapse> : checklist(job.checklist))}
    {job.templates?.map(template => <div key={template.id} className="mt-4"><strong>{template.name}</strong><div className="text-xs text-gray-500">{template.submitted_at ? `Submitted ${template.submitted_at}` : 'No submission yet'}</div>{checklist(template.items || [])}</div>)}
    {!job.checklist?.length && !job.templates?.length && <p>No checklist is linked to this cleaning task.</p>}
  </Card>)}</div>;
}
